module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_rodur_a.7d90a4e3.png";